import React from 'react';
import styles from './M_UserDonationListItem.module.css';
import { formatPrice } from '@/utils/formatters';
import cn from 'classnames';

interface M_UserDonationListItemProps {
  userName: string;
  donationAmount: number;
  userAvatar: string;
}

export default function M_UserDonationListItem({
  userName,
  donationAmount,
  userAvatar,
}: M_UserDonationListItemProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.user_info_wrapper}>
        <div className={styles.user_avatar_wrapper}>
          <img src={userAvatar} alt={userName} />
        </div>
        <span className={cn(styles.user_name, 'text-p-2')}>{userName}</span>
      </div>
      <span className={cn(styles.donation_amount, 'text-p-2')}>
        + {formatPrice(donationAmount)}
      </span>
    </div>
  );
}
